import { invoiceStatusOptions } from "@utils/constants";

export const invoiceStatusFlow = {
  0: {
    1: [0, 1, 10, 9],
    2: [0, 1, 9],
  },
  10: [10],
  9: [9, 0, 1],
  1: [1, 2, 9],
  2: [2],
  3: {
    1: [3, 8, 4, 5],
    2: [3, 6, 7],
  },
  8: [8, 3, 4, 5],
  4: [4, 3, 8],
  5: [5, 3, 8, 4],
  6: [6, 3],
  7: [7, 3, 6],
};

export const getInvoiceStatusOptions = (t, statusId, documentType) => {
  const allStatuses = invoiceStatusOptions(t);

  const flow = invoiceStatusFlow[statusId];

  const allowedIds = Array.isArray(flow) ? flow : flow?.[documentType] || [];

  return allStatuses.filter(
    ({ value }) => value !== "" && allowedIds.includes(value)
  );
};

export const getInvoiceStatus = (t, statusId) =>
  invoiceStatusOptions(t).find(({ value }) => value === statusId);